export const TASK_RESPONSIBLE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.Tasks.TaskResponsibleUpdated";
export const DOCUMENT_TASKS_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.Tasks.DocumentTasksChanged";
